export const cartLine = `
id
quantity
attributes {
  key
  value
}
cost {
  totalAmount {
    amount
    currencyCode
  }
}
merchandise {
  ... on ProductVariant {
    id
    quantityAvailable
    product {
      ... on Product {
        title
        handle
      }
    }
  }
}
`;

export const cart = `
checkoutUrl
id
totalQuantity
cost {
  subtotalAmount {
    amount
    currencyCode
  }
}
lines(first: 50) {
  edges {
    node {
      ${cartLine}
    }
  }
}
`;

export const variant = `
availableForSale
id
price {
  amount
  currencyCode
}
compareAtPrice {
  amount
  currencyCode
}
selectedOptions {
  name
  value
}
images: metafield(namespace: "media", key: "images") {
  references(first: 15){
    edges {
      node {
        ... on MediaImage {
          image {
            alt: altText
            height
            id
            src: url(transform: { preferredContentType: WEBP })
            width
          }
        }
      }
    }
  }
}
`;

export const product = `
availableForSale
handle
id
title
handle
tags
images(first: 50) {
  edges {
    node {
      alt: altText
      height
      id
      src: url(transform: { preferredContentType: WEBP })
      width
    }
  }
}
options {
  name
  optionValues {
    name
    swatch {
      color
      image {
        previewImage {
          url
        }
      }
    }
  }
}
priceRange {
  minVariantPrice {
    amount
    currencyCode
  }
}
compareAtPriceRange {
  minVariantPrice {
    amount
    currencyCode
  }
}
variants(first: 250) {
  edges {
    node {
      ${variant}
    }
  }
}
category: metafield(namespace: "lig", key: "DepartmentRefine") {
  value
}
saleVariant: metafield(namespace: "custom", key: "sale_product") {
  value
}
gan: metafield(namespace: "custom", key: "gan") {
  value
}
master_id: metafield(namespace: "lig", key: "master_id") {
  value
}
customizerBackgroundImageUrl: metafield(namespace: "custom", key: "customizer_background_image") {
  reference {
    ... on MediaImage {
      image {
        url
      }
    }
  }
}
`;
